import AuthError from '../domain/AuthError';
import OrderNotFoundError from '../domain/OrderNotFoundError';

const API_MESSAGE_TRANSLATIONS = {
  'Operation performed successfully': 'Operación realizada correctamente.',
  'An error occurred while processing the request': 'Ocurrió un error al procesar la solicitud.',
  'Access denied due to invalid credentials.': 'Acceso denegado por credenciales inválidas.',
  'The requested resource was not found.': 'No se encontró el recurso solicitado.',
  'The requested resource could not be found.': 'No se encontró el recurso solicitado.',
  'Bad request.': 'Solicitud inválida.',
  'Too many requests.': 'Demasiadas solicitudes. Intenta de nuevo más tarde.',
  'Conflict.': 'La solicitud no pudo completarse por conflicto de estado.',
  'Gone.': 'El recurso solicitado ya no está disponible.',
  'The resource is locked.': 'El recurso solicitado está bloqueado.',
  Unauthorized: 'No autorizado.',
  Forbidden: 'Acceso denegado.',
  'Internal server error.': 'Error interno del servidor.',
};

function translateApiMessage(message) {
  if (typeof message !== 'string') {
    return message;
  }

  return API_MESSAGE_TRANSLATIONS[message] || message;
}

function getApiErrorMessage(payload) {
  if (!payload) {
    return undefined;
  }

  if (payload.errorDescription) {
    return translateApiMessage(payload.errorDescription);
  }

  const responseError = payload.error || {};

  if (Array.isArray(responseError.errors) && responseError.errors.length > 0) {
    const [firstError] = responseError.errors;

    if (typeof firstError === 'string') {
      return translateApiMessage(firstError);
    }

    if (firstError && typeof firstError === 'object') {
      return translateApiMessage(firstError.message || firstError.errorMessage);
    }
  }

  return translateApiMessage(responseError.errorMessage || payload.message);
}

function isInvalidCredentialsLoginPayload(payload) {
  const errors = Array.isArray(payload?.error?.errors)
    ? payload.error.errors.map((item) => String(item).toLowerCase())
    : [];

  return errors.includes('correo inválido');
}

function isCustomerDataNotFoundOtpPayload(payload) {
  const originalMessage = String(
    payload?.errorDescription || payload?.error?.errorMessage || payload?.message || '',
  ).toLowerCase();
  const normalizedMessage = String(getApiErrorMessage(payload) || '').toLowerCase();

  return (
    normalizedMessage.includes('no se encontraron datos de cliente para la orden indicada')
    || originalMessage.includes('the requested resource could not be found')
    || originalMessage.includes('the requested resource was not found')
  );
}

function buildApiError(payload) {
  if (isCustomerDataNotFoundOtpPayload(payload)) {
    return new OrderNotFoundError();
  }

  return new AuthError(getApiErrorMessage(payload));
}

export function mapLoginApiError(payload) {
  if (isInvalidCredentialsLoginPayload(payload)) {
    return new OrderNotFoundError();
  }

  return new AuthError();
}

export function mapOtpApiError(payload) {
  return buildApiError(payload);
}

export function buildAuthError(error) {
  return buildApiError(error?.response?.data);
}
